import React from 'react';
import { getFontColor } from '@/lib/colors/colors';
import { useChatWidgetContext } from '@/widget/services/useChatWidgetContext';
import styles from './Captions.module.scss';

function Captions() {
  const { settings } = useChatWidgetContext();
  const { color } = settings;

  return (
    <>
      <div className={styles.caption} style={{ color: getFontColor(color) }}>
        {window.ChatWidget.i18n.t('chat_widget.hello')}
      </div>
      <div className={styles.subCaption} style={{ color: getFontColor(color) }}>
        {window.ChatWidget.i18n.t('chat_widget.help')}
      </div>
    </>
  );
}

export default Captions;
